export const MIN_PASSWORD_LENGTH = 5
export const BLOCKED_USER = 109
export const studentInfo = 'studentInfo'
